import { defineMessages } from 'react-intl';

export default defineMessages({
    aboutThePortal: {
        id: 'faq.sections.About the Portal',
        defaultMessage: 'About the Portal',
    },
    aboutThePortalQ: {
        id: 'faq.topics.about_portal_for_producers.question',
        defaultMessage: 'Can I report all claims via Allianz Claims Hub?',
    },
    aboutThePortalA: {
        id: 'faq.topics.about_portal_for_producers.answer.long',
        defaultMessage: 'No, at this time you can only report Motor Fleet claims via Allianz Claims Hub.',
    },
    sevInjuryQ: {
        id: 'faq.topics.sev_injury_for_producers.question',
        defaultMessage: 'Can I use Allianz Claims Hub to report a claim where there is a severe injury or fatality?',
    },
    sevInjuryA: {
        id: 'faq.topics.sev_injury_for_producers.answer.long',
        defaultMessage: 'No, in these circumstances please contact our Motor Claims team on 0330 102 1998.',
    },
    windScreenQ: {
        id: 'faq.topics.wind_screen_for_producers.question',
        defaultMessage: 'Can I use Allianz Claims Hub to report a windscreen claim?',
    },
    windScreenA: {
        id: 'faq.topics.wind_screen_for_producers.answer.long',
        defaultMessage: 'No, please continue to report windscreen claims via the Autoglass website. Go to ‘Useful Links’ at the top left hand corner of your screen to select the Autoglass link.',
    },
    uploadDocsQ: {
        id: 'faq.topics.upload_docs_for_producers.question',
        defaultMessage: 'How do I upload documents, photos and videos?',
    },
    uploadDocsA: {
        id: 'faq.topics.upload_docs_for_producers.answer.long',
        defaultMessage: 'You’ll be guided how to upload documents, photos and videos as you go through the notification of your claim.If you’ve already notified your claim:Documents & PhotosNavigate to the Claims page via the home icon at the top left hand corner.  Search for the claim using the search bar.  Clicking the claim number will take you to ‘Claim Details’.From here, click on the ‘Documents’ tab where you’ll see an ‘Upload Documents’ button.Video uploads:To upload a video, go to ‘Useful Links’ at the top left hand corner of your screen and select ‘Upload Video’ from the drop down. It’s important to note that you will need your claim reference number to upload any videos. This is so that the video is linked to the correct claim.',
    },
    doctypeQ: {
        id: 'faq.topics.doc_type_for_producers.question',
        defaultMessage: 'Which types of documents can I upload?',
    },
    doctypeA: {
        id: 'faq.topics.doc_type_for_producers.answer.long',
        defaultMessage: 'Any documents in the following formats will be accepted: .bmp, .doc, .docx, .gif, .jpg, .msg, .pdf, .pjpeg, .pps, .ppt, .pptx, .ps, .rtf, .sv, .tif, .tiff, .wav, .wma, .xls,  .xlsx',
    },
    docSizeQ: {
        id: 'faq.topics.doc_size_for_producers.question',
        defaultMessage: 'Is there a size limit for uploading documents and videos?',
    },
    docSizeA: {
        id: 'faq.topics.doc_size_for_producers.answer.long',
        defaultMessage: 'For document upload there is a size limit of 20MB. For videos there is no limit on size.',
    },
    repairMethodQ: {
        id: 'faq.topics.repair_method_for_producers.question',
        defaultMessage: 'Which repair method do I select if I have preferred approved repairer?',
    },
    repairMethodA: {
        id: 'faq.topics.repair_method_for_producers.answer.long',
        defaultMessage: 'In this instance, please select ‘I’ll provide repair facilities details myself’.  Our handler will then appoint your preferred approved repairer for you.  Please note that some service levels may be impacted by having a single preferred approved repairer.',
    },
    reportInfoQ: {
        id: 'faq.topics.report_info_for_producers.question',
        defaultMessage: 'What if I need to make the handler aware of other information when reporting a new claim?',
    },
    reportInfoA: {
        id: 'faq.topics.report_info_for_producers.answer.long',
        defaultMessage: 'On the Summary page towards the end of notification you’ll be able to add a note which will go directly to your claims handler.',
    },
    reportProbQ: {
        id: 'faq.topics.report_probs_for_producers.question',
        defaultMessage: 'What do I do if I am having problems reporting my claim?',
    },
    reportProbA: {
        id: 'faq.topics.report_probs_for_producers.answer.long',
        defaultMessage: 'If you’re having issues, we’d recommend that you contact our Motor Claims team to report the claim on 0330 102 1998.Please also email digitalsupport@allianz.co.uk with details of the issue and your contact so we can investigate and resolve the issue for you.',
    },
    financeInfoQ: {
        id: 'faq.topics.finance_info_for_producers.question',
        defaultMessage: 'How do I access financial information?',
    },
    financeInfoA: {
        id: 'faq.topics.finance_info_for_producers.answer.long',
        defaultMessage: 'Search for your claim using the search bar. Click on the claim number which will take you to ‘Claim Details’.  Then click the Financial tab.',
    },
    claimStatusQ: {
        id: 'faq.topics.claim_status_for_producers.question',
        defaultMessage: 'How do I check the present position of a claim?',
    },
    claimStatusA: {
        id: 'faq.topics.claim_status_for_producers.answer.long',
        defaultMessage: 'You can easily see whether a claim is Open or Closed by searching for it in the list of your existing claims on the Claims page.To see further details, click on the claim number which will take you to ‘Claim Details’. In ‘Financial Summary’ you will be able to see a list of loss types. Each loss type will display whether it is Open or Closed.',
    },
    openClaimQ: {
        id: 'faq.topics.open_claim_for_producers.question',
        defaultMessage: 'Why is my claim still showing as open?',
    },
    openClaimA: {
        id: 'faq.topics.open_claim_for_producers.answer.long',
        defaultMessage: 'From the Claims page:Use the search bar to find your claim. Click on the claim number which will take you to ‘Claim Details’.From the ‘Claim Details’ page:Click on the ‘Financial Summary’ tab. Here you’ll be able to see a list of loss types. Each loss type will have ‘open’ or ‘closed’ against it.  If any of the loss types are still open, for example recoveries, then the overall status of the claim will remain open. Only when all loss types are closed will your claim’s status be changed to closed.',
    },
    feedbackQ: {
        id: 'faq.topics.feedback_for_producers.question',
        defaultMessage: 'How do I provide feedback about the Allianz Claims Hub?',
    },
    feedbackA: {
        id: 'faq.topics.feedback_for_producers.answer.long',
        defaultMessage: 'We’d love to hear your feedback on Allianz Claims Hub so we can continue to improve your experience with Allianz.You can do this online: Go to ‘Useful Links’ at the top left hand corner of your screen and select ‘Claims Hub Feedback’ from the drop down. You can also provide feedback at any time to your Allianz representative.',
    }
});
